
<div class="form-group">
  <label for="name" class="col-sm-2 control-label">Portfolio</label>
  <div class="col-sm-10">
    <app-portfolio-select [model]="modification"></app-portfolio-select>
  </div>
</div>

<div class="form-group">
  <label for="name" class="col-sm-2 control-label">Name</label>
  <div class="col-sm-10">
    <input type="text" class="form-control" name="name" id="name" placeholder="Modification Name"
           [(ngModel)]="modification.name" required>
  </div>
</div>

<div class="form-group">
  <label for="description" class="col-sm-2 control-label">Description</label>
  <div class="col-sm-10">
    <textarea class="form-control" name="description" id="description" placeholder="Modification Description" [(ngModel)]="modification.description" required></textarea>
  </div>
</div>

<div class="form-group">
  <div class="col-sm-offset-2 col-sm-10 text-right">
    <button type="submit" class="btn btn-success">Save</button>
  </div>
</div>
